
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/physicians",
      function () {
        return require("private-next-pages/physicians.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/physicians"])
      });
    }
  